export const departmentsColumns = (t: any) => [
    {
      key: "column1",
      name: t("nav.city"),
      fieldName: "city",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "column2",
      name: t("nav.postalCode"),
      fieldName: "postalCode",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column3",
      name: t("nav.street"),
      fieldName: "street",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
  ];
  
  export const generateDepartments = (Departments: any) => {
    const items: Array<any> = [];
  
    Departments.forEach((department: any) => {
      items.push({
        key: department.id,
        id: department.id,
        city: department.city,
        postalCode: department.postalCode,
        street: department.street,
      });
    });
  
    return [...items];
  };